export const subscriptionPlans = {
  homebuyer_basic: "Homebuyer Basic",
  homebuyer_premium: "Homebuyer Premium",
  agent_zip_code: "Agent Premium",
  loan_officer_state: "Loan officer Premium",
  agent_basic: "Agent Basic",
  loan_officer_basic: "Loan Officer Basic",
};
